import { render, staticRenderFns } from "./mergeDepth.vue?vue&type=template&id=7d2803a5&scoped=true&"
import script from "./mergeDepth.vue?vue&type=script&lang=js&"
export * from "./mergeDepth.vue?vue&type=script&lang=js&"
import style0 from "./mergeDepth.vue?vue&type=style&index=0&id=7d2803a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2803a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d2803a5')) {
      api.createRecord('7d2803a5', component.options)
    } else {
      api.reload('7d2803a5', component.options)
    }
    module.hot.accept("./mergeDepth.vue?vue&type=template&id=7d2803a5&scoped=true&", function () {
      api.rerender('7d2803a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/depth/mergeDepth.vue"
export default component.exports